<template>
    <div v-html="html"></div>
</template>

<script>
const styleOrEmpty = (value, name) => (value ? `${name}:${value};` : '');

export const buildDefaultHtml = (props = {}) => {
    const src = props.src || '';
    const alt = props.alt || 'Imagen';
    const width = styleOrEmpty(props.width, 'width');
    const height = styleOrEmpty(props.height, 'height');
    const maxWidth = styleOrEmpty(props.maxWidth, 'max-width');
    const padding = styleOrEmpty(props.padding, 'padding');
    const background = styleOrEmpty(props.backgroundColor, 'background');
    const align = props.align || 'center';
    const image = `<img src="${src}" alt="${alt}" style="${width}${height}${maxWidth}display:inline-block;vertical-align:top;" />`;
    const linked = props.linkUrl
        ? `<a href="${props.linkUrl}"${props.openNewTab ? ' target="_blank" rel="noopener"' : ''}>${image}</a>`
        : image;
    return `<div style="text-align:${align};${padding}${background}">${linked}</div>`;
};

export default {
    name: 'MailingBlockImage',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
